import { useMutation, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import * as QueryString from "query-string";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { CURRENT_USER } from "../graphql/queries";
import { getFrontendUrl } from "../utils/urls";
import SignupForm from "./signup/GoogleSignupForm";
import { Spinner } from "evergreen-ui";
import ErrorShowIntercom from "./shared/ErrorShowIntercom";

const VERIFY_LOGIN_BROWSER = gql`
  mutation VerifyLoginThroughBrowser($input: VerifyLoginInput!) {
    verifyLoginThroughBrowser(input: $input) {
      error {
        message
      }
      success
    }
  }
`;

type Props = {} & RouteComponentProps;

function AuthBrowserPage(props: Props) {
  const { location } = props;
  const params = QueryString.parse(location.search);
  const { ident } = params;

  // hooks
  const [isComplete, setIsComplete] = React.useState(false);
  const { loading: meLoading, error: meError, data: meData } = useQuery(
    CURRENT_USER
  );
  const [verifyLogin, { loading: verifyLoading }] = useMutation(
    VERIFY_LOGIN_BROWSER
  );
  React.useEffect(() => {
    if (!ident) {
      // If no query string with a token, redirect to home
      window.location.replace(getFrontendUrl());
    }
  });

  React.useEffect(() => {
    if (meData && meData.me && meData.me.user) {
      // We're logged in already, get accessToken from localStorage
      const authToken = localStorage.getItem("omnitionauthtoken");
      if (authToken) {
        verifyLogin({
          variables: {
            input: {
              identifyingToken: ident,
              authToken
            }
          }
        }).then(data => {
          setIsComplete(true);
        });
      }
    }
  }, [meData, ident, verifyLogin, isComplete]);

  if (meLoading) {
    return (
      <div>
        <Spinner></Spinner>
      </div>
    );
  } else if (meError) {
    return <ErrorShowIntercom></ErrorShowIntercom>;
  }

  if (verifyLoading) {
    return (
      <div>
        <p>Verifying login...</p>
      </div>
    );
  }

  if (!ident) {
    return (
      <div>
        <p>Invalid login request. Redirecting...</p>
      </div>
    );
  }

  if (isComplete) {
    return (
      <div>
        <p>
          Successfully logged in! You can now close this tab and return to the
          app.
        </p>
      </div>
    );
  }

  const handleLogin = (authToken: string) => {
    verifyLogin({
      variables: {
        input: {
          identifyingToken: ident,
          authToken
        }
      }
    }).then(data => {
      setIsComplete(true);
    });
  };

  // Show login form
  return (
    <div>
      <SignupForm onLogin={handleLogin}></SignupForm>
      <p>here is the auth browser</p>
    </div>
  );
}

export default AuthBrowserPage;
